// Regras puras das telas de Listas/Arquivos do módulo Campanhas (estado do
// WhatsApp de um contato, iniciais e cor do avatar, contagem de arquivos).
// Sem React — testado em __tests__/contactListRules.test.js.
import { i18n } from "../../translate/i18n";
import { AEROS } from "../../styles/aerosTokens";

// Três estados, não dois: "não verificado" (null/undefined) não é a mesma
// coisa que "inválido". A checagem depende de conexão QR Code, e pintar de
// bloqueado quem nunca foi checado fazia a lista inteira parecer imprestável.
export const WHATSAPP_VALIDITY = Object.freeze({
  valid: { tone: "toneSuccess", labelKey: "contactListItems.validity.valid" },
  invalid: { tone: "toneNeutral", labelKey: "contactListItems.validity.invalid" },
  unknown: { tone: "toneWarning", labelKey: "contactListItems.validity.unknown" },
});

// isWhatsappValid: true | false | null/undefined → chave de estado.
export const whatsappValidityKey = (isWhatsappValid) => {
  if (isWhatsappValid === true) return "valid";
  if (isWhatsappValid === false) return "invalid";
  return "unknown";
};

// { key, tone, label, title } pronto para a pill da tabela. `title` é o texto
// longo do tooltip, que explica o estado "não verificado".
export const whatsappValidity = (isWhatsappValid) => {
  const key = whatsappValidityKey(isWhatsappValid);
  const meta = WHATSAPP_VALIDITY[key];
  return {
    key,
    tone: meta.tone,
    label: i18n.t(meta.labelKey),
    title: i18n.t(`contactListItems.validity.${key}Hint`),
  };
};

// Até duas iniciais, para o avatar da linha.
export const initials = (name) =>
  String(name || "")
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0])
    .join("")
    .toUpperCase();

// Cor estável por id, do ciclo de avatares do design system.
export const avatarColor = (id) => {
  const cycle = AEROS.avatarCycle;
  const n = Number(id);
  const index = Number.isFinite(n) ? Math.abs(Math.trunc(n)) : 0;
  return cycle[index % cycle.length];
};

// Sublinha "N contatos" / "N arquivos". Devolve null quando a contagem não
// veio do backend, para a tela omitir a linha em vez de mostrar "0".
export const countLabel = (count, singularKey, pluralKey) => {
  if (count === null || count === undefined) return null;
  const n = Number(count);
  if (!Number.isFinite(n)) return null;
  return i18n.t(n === 1 ? singularKey : pluralKey, { count: n });
};

export const contactsCountLabel = (count) =>
  countLabel(count, "contactLists.countOne", "contactLists.countOther");

export const filesCountLabel = (count) =>
  countLabel(count, "files.countOne", "files.countOther");

// Busca client-side das linhas já carregadas (nome da lista/arquivo).
export const matchesNameSearch = (name, term) => {
  const norm = (s) =>
    String(s || "")
      .normalize("NFD")
      .replace(/[̀-ͯ]/g, "")
      .toLowerCase()
      .trim();
  const q = norm(term);
  if (!q) return true;
  return norm(name).includes(q);
};
